import { useEffect, useState, useMemo } from "react";
import * as animationData from "../../../../assets/lotties/countdown.json";
import { useApp } from "../../../../services/app-context";
import { getLabel } from "../../utils/labels";

interface CertificationLoadingProps {
  countdownFrom?: number;
  onCountdownComplete?: () => void;
}

export function CertificationLoading({ 
  countdownFrom = 3,
  onCountdownComplete,
}: CertificationLoadingProps) {
  const { certificationAssets } = useApp();
  const labels = certificationAssets?.labels ?? {};
  const [countdown, setCountdown] = useState(countdownFrom);
  
  // Filter out text layers (ty: 5) which contain the countdown numbers
  const filteredAnimationData = useMemo(() => {
    const data = JSON.parse(JSON.stringify(animationData));
    if (data.layers) {
      data.layers = data.layers.filter((layer: any) => layer.ty !== 5);
    }
    return data;
  }, []);

  useEffect(() => {
    if (countdown <= 0) {
      onCountdownComplete?.();
      return;
    }

    const duration = 1000; // 1000 ms per countdown number

    // Decrement countdown after 1 second
    const timer = setTimeout(() => {
      setCountdown((prev) => prev - 1);
    }, duration);

    return () => {
      clearTimeout(timer);
    };
  }, [countdown, onCountdownComplete]);

  return (
    <div className="fixed z-[4] bg-callLoadingBg top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center gap-8">
      {/* Title above countdown */}
      <h1 className="text-large-title text-text-secondary font-pp-bold">
        Preparing {getLabel("certification.singular", labels)}
      </h1>

      {/* Circular spinner */}
      <div className="w-32 h-32 border-8 border-gray-300 border-t-white rounded-full animate-spin"></div>
    </div>
  );
}

